import { Country } from '../../enums';

const globalizedFaqs: Partial<Record<Country, { [key: string] : string; }>> = {
  [Country.FR]: {
    premiumPlan: 'why_do_i_need_premium.frpp',
    customDomain: 'custom_domain.frpp',
    freeDomain: 'free_domain.frpp',
    domainPurchasedElswhere: 'domain_purchased_elsewhere.frpp',
    emailAddress: 'personalized_email_address.frpp',
    searchEngines: 'visible_search_engines.frpp',
    siteContentOwnership: 'site_content_ownership.frpp',
    gdprCompilant: 'gdpr_compliant.frpp',
    whereAreServersLocated: 'where_are_servers_located.frpp',
    acceptOnlinePayment: 'accepted_online_payments.frpp',
    cancelMyPlan: 'cancel_my_plan.frpp',
    subscriptionCycle: 'subscription_charge_cycle.frpp',
  },
  [Country.JA]: {
    premiumPlan: 'premium_plan.japanpp',
    planDifferences: 'plan_differences.japanpp',
    customDomain: 'custom_domain.japanpp',
    customDomainsBenfits: 'custom_domain_benefits.japanpp',
    personalizedEmailAddress: 'personalized_email_address.japanpp',
    checkPaymentDetails: 'check_payment_details.japanpp',
    paymentMethods: 'payment_methods.japanpp',
  },
};

export const getSpecifiedCountryFaqs = ({ country }: { country: Country }) => {
  return globalizedFaqs[country]!;
};